import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import adminApi from "@/lib/adminApi";
import BrandMark from "@/components/BrandMark";

export default function AdminVerifyEmail() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("verifying");
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); return; }
    (async () => {
      try {
        const { data } = await adminApi.get(`/change-email/verify?token=${encodeURIComponent(token)}`);
        setEmail(data.email);
        setState("ok");
        toast.success("Email updated");
      } catch (err) {
        setState("error");
        toast.error(err?.response?.data?.detail || "Verification failed");
      }
    })();
  }, [token]);

  return (
    <div className="min-h-[100dvh] bg-[#FBF9F6] grain flex items-center justify-center px-6">
      <div className="w-full max-w-sm text-center">
        <BrandMark variant="center" className="mb-8" />
        <div className="text-[10px] font-[Manrope] font-bold tracking-[0.3em] uppercase text-[#6B7A54] mb-4">Aynora · Admin</div>
        {state === "verifying" && <div className="font-[Cormorant_Garamond] italic text-2xl text-stone-700">Verifying…</div>}
        {state === "ok" && (
          <>
            <h1 className="font-[Cormorant_Garamond] text-3xl italic text-stone-900">All set.</h1>
            <p className="mt-3 text-sm font-[Manrope] text-stone-600">Your admin email is now <strong>{email}</strong>.</p>
            <button onClick={() => navigate("/admin/settings")} className="btn-primary mt-6">Back to settings</button>
          </>
        )}
        {state === "error" && (
          <>
            <h1 className="font-[Cormorant_Garamond] text-3xl italic text-stone-900">Link invalid or expired.</h1>
            <button onClick={() => navigate("/admin/settings")} className="btn-primary mt-6">Back to settings</button>
          </>
        )}
      </div>
    </div>
  );
}
